var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartOutline = function SvgHeartOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#HeartOutline_svg__clip0_1238_432101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 12.5721L12.0001 20.0001L4.50006 12.5721C4.00536 12.0907 3.6157 11.5121 3.3556 10.8727C3.09551 10.2333 2.97062 9.54701 2.98879 8.85699C3.00697 8.16697 3.16782 7.48819 3.46121 6.86339C3.75461 6.23859 4.17419 5.68131 4.69354 5.22663C5.21289 4.77196 5.82076 4.42974 6.47887 4.22154C7.13697 4.01333 7.83106 3.94364 8.51743 4.01686C9.20379 4.09007 9.86756 4.30461 10.4669 4.64696C11.0663 4.98931 11.5883 5.45205 12.0001 6.00605C12.4136 5.45608 12.9362 4.99738 13.5352 4.65866C14.1341 4.31994 14.7966 4.1085 15.481 4.03757C16.1654 3.96665 16.8571 4.03775 17.5128 4.24645C18.1685 4.45514 18.7741 4.79693 19.2916 5.25042C19.8091 5.70391 20.2275 6.25934 20.5205 6.88195C20.8135 7.50456 20.9748 8.18094 20.9944 8.86876C21.0139 9.55659 20.8913 10.241 20.6342 10.8793C20.3771 11.5176 19.991 12.0959 19.5001 12.5781",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "HeartOutline_svg__clip0_1238_432101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};
export default SvgHeartOutline;